// ─── Bikram Sambat (BS) Date Utilities ───────────────────────────────────────
// BS months have variable days; this lookup covers 2000–2090 BS
export const BS_MONTH_DAYS = {
  2000:[30,32,31,32,31,30,30,30,29,30,29,31],
  2001:[31,31,32,31,31,31,30,29,30,29,30,30],
  2002:[31,31,32,32,31,30,30,29,30,29,30,30],
  2003:[31,32,31,32,31,30,30,30,29,29,30,31],
  2004:[30,32,31,32,31,30,30,30,29,30,29,31],
  2005:[31,31,32,31,31,31,30,29,30,29,30,30],
  2006:[31,31,32,32,31,30,30,29,30,29,30,30],
  2007:[31,32,31,32,31,30,30,30,29,29,30,31],
  2008:[31,31,31,32,31,31,29,30,30,29,29,31],
  2009:[31,31,32,31,31,31,30,29,30,29,30,30],
  2010:[31,31,32,32,31,30,30,29,30,29,30,30],
  2011:[31,32,31,32,31,30,30,30,29,29,30,31],
  2012:[31,31,31,32,31,31,29,30,30,29,30,30],
  2013:[31,31,32,31,31,31,30,29,30,29,30,30],
  2014:[31,31,32,32,31,30,30,29,30,29,30,30],
  2015:[31,32,31,32,31,30,30,30,29,29,30,31],
  2016:[31,31,31,32,31,31,29,30,30,29,30,30],
  2017:[31,31,32,31,31,31,30,29,30,29,30,30],
  2018:[31,32,31,32,31,30,30,29,30,29,30,30],
  2019:[31,32,31,32,31,30,30,30,29,30,29,31],
  2020:[31,31,31,32,31,31,30,29,30,29,30,30],
  2021:[31,31,32,31,31,31,30,29,30,29,30,30],
  2022:[31,32,31,32,31,30,30,30,29,29,30,30],
  2023:[31,32,31,32,31,30,30,30,29,30,29,31],
  2024:[31,31,31,32,31,31,30,29,30,29,30,30],
  2025:[31,31,32,31,31,31,30,29,30,29,30,30],
  2026:[31,32,31,32,31,30,30,30,29,29,30,31],
  2027:[30,32,31,32,31,30,30,30,29,30,29,31],
  2028:[31,31,32,31,31,31,30,29,30,29,30,30],
  2029:[31,31,32,31,32,30,30,29,30,29,30,30],
  2030:[31,32,31,32,31,30,30,30,29,29,30,31],
  2031:[31,31,31,32,31,31,30,29,30,29,30,30],
  2032:[31,31,32,31,31,31,30,29,30,29,30,30],
  2033:[31,32,31,32,31,30,30,30,29,29,30,30],
  2034:[31,32,31,32,31,30,30,30,29,30,29,31],
  2035:[31,31,31,32,31,31,30,29,30,29,30,30],
  2036:[31,31,32,31,31,31,30,29,30,29,30,30],
  2037:[31,32,31,32,31,30,30,30,29,29,30,31],
  2038:[31,31,31,32,31,31,29,30,30,29,29,31],
  2039:[31,31,32,31,31,31,30,29,30,29,30,30],
  2040:[31,31,32,32,31,30,30,29,30,29,30,30],
  2041:[31,32,31,32,31,30,30,30,29,29,30,31],
  2042:[31,31,31,32,31,31,29,30,29,30,29,31],
  2043:[31,31,32,31,31,31,30,29,30,29,30,30],
  2044:[31,31,32,32,31,30,30,29,30,29,30,30],
  2045:[31,32,31,32,31,30,30,30,29,29,30,31],
  2046:[31,31,31,32,31,31,29,30,30,29,29,31],
  2047:[31,31,32,31,31,31,30,29,30,29,30,30],
  2048:[31,31,32,32,31,30,30,29,30,29,30,30],
  2049:[31,32,31,32,31,30,30,30,29,30,29,31],
  2050:[31,31,31,32,31,31,29,30,30,29,30,30],
  2051:[31,31,32,31,31,31,30,29,30,29,30,30],
  2052:[31,31,32,32,31,30,30,29,30,29,30,30],
  2053:[31,32,31,32,31,30,30,30,29,29,30,31],
  2054:[31,31,31,32,31,31,29,30,30,29,30,30],
  2055:[31,31,32,31,31,31,30,29,30,29,30,30],
  2056:[31,32,31,32,31,30,30,29,30,29,30,30],
  2057:[31,32,31,32,31,30,30,30,29,29,30,31],
  2058:[31,31,31,32,31,31,29,30,30,29,30,30],
  2059:[31,31,32,31,31,31,30,29,30,29,30,30],
  2060:[31,32,31,32,31,30,30,30,29,29,30,31],
  2061:[30,32,31,32,31,30,30,30,29,30,29,31],
  2062:[31,31,32,31,31,31,30,29,30,29,30,30],
  2063:[31,31,32,32,31,30,30,29,30,29,30,30],
  2064:[31,32,31,32,31,30,30,30,29,29,30,31],
  2065:[31,31,31,32,31,31,29,30,30,29,30,30],
  2066:[31,31,32,31,31,31,30,29,30,29,30,30],
  2067:[31,32,31,32,31,30,30,30,29,29,30,31],
  2068:[31,31,31,32,31,31,29,30,30,29,30,30],
  2069:[31,31,32,31,31,31,30,29,30,29,30,30],
  2070:[31,32,31,32,31,30,30,30,29,29,30,31],
  2071:[31,31,31,32,31,31,29,30,30,29,30,30],
  2072:[31,31,32,31,31,31,30,29,30,29,30,30],
  2073:[31,31,32,32,31,30,30,29,30,29,30,30],
  2074:[31,32,31,32,31,30,30,30,29,29,30,31],
  2075:[31,31,31,32,31,31,29,30,30,29,30,30],
  2076:[31,31,32,31,31,31,30,29,30,29,30,30],
  2077:[31,32,31,32,31,30,30,30,29,29,30,30],
  2078:[31,32,31,32,31,30,30,30,29,30,29,31],
  2079:[31,31,31,32,31,31,30,29,30,29,30,30],
  2080:[31,31,32,31,31,31,30,29,30,29,30,30],
  2081:[31,32,31,32,31,30,30,30,29,29,30,31],
  2082:[30,32,31,32,31,30,30,30,29,30,29,31],
  2083:[31,31,32,31,31,31,30,29,30,29,30,30],
  2084:[31,31,32,32,31,30,30,29,30,29,30,30],
  2085:[31,32,31,32,31,30,30,30,29,29,30,31],
  2086:[31,31,31,32,31,31,29,30,30,29,30,30],
  2087:[31,31,32,31,31,31,30,29,30,29,30,30],
  2088:[31,32,31,32,31,30,30,30,29,29,30,31],
  2089:[30,32,31,32,31,30,30,30,29,30,29,31],
  2090:[31,31,32,31,31,31,30,29,30,29,30,30],
};

export const BS_MONTHS = ["Baisakh","Jestha","Ashadh","Shrawan","Bhadra","Ashwin","Kartik","Mangsir","Poush","Magh","Falgun","Chaitra"];

// AD epoch: BS 2000/1/1 = AD 1943/4/14
export const BS_EPOCH_AD = new Date(1943, 3, 14); // month is 0-indexed

export function bsTotalDays(y, m, d) {
  let total = 0;
  for (let yr = 2000; yr < y; yr++) {
    const row = BS_MONTH_DAYS[yr];
    if (row) row.forEach(days => total += days);
  }
  const row = BS_MONTH_DAYS[y];
  if (row) for (let mi = 0; mi < m - 1; mi++) total += row[mi];
  return total + d - 1;
}

export function bsToAd(y, m, d) {
  const days = bsTotalDays(y, m, d);
  const ad = new Date(BS_EPOCH_AD);
  ad.setDate(ad.getDate() + days);
  return ad;
}

export function adToBs(date) {
  const diff = Math.floor((date - BS_EPOCH_AD) / 86400000);
  let remaining = diff;
  let y = 2000;
  while (true) {
    const row = BS_MONTH_DAYS[y];
    if (!row) break;
    const total = row.reduce((a,b)=>a+b,0);
    if (remaining < total) break;
    remaining -= total;
    y++;
  }
  const row = BS_MONTH_DAYS[y] || BS_MONTH_DAYS[2080];
  let m = 1;
  for (let mi = 0; mi < 12; mi++) {
    if (remaining < row[mi]) { m = mi+1; break; }
    remaining -= row[mi];
  }
  return { y, m, d: remaining + 1 };
}

export function formatBs(bsObj) {
  if (!bsObj || !bsObj.y) return "";
  return `${bsObj.y}-${String(bsObj.m).padStart(2,"0")}-${String(bsObj.d).padStart(2,"0")}`;
}

export function parseBsStr(str) {
  if (!str) return null;
  const parts = str.split("-");
  if (parts.length !== 3) return null;
  const y = parseInt(parts[0]), m = parseInt(parts[1]), d = parseInt(parts[2]);
  if (isNaN(y)||isNaN(m)||isNaN(d)) return null;
  return { y, m, d };
}
